﻿import { defineComponent, inject, onMounted, ref } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "Enterprise",

    props: {
        webSite: {
            type: String,
            required: true,
        },
    },
    components: {},
    setup() {
        const compId = inject("compId", "");
        const usrId = inject("usrId", "");
        const compInfo = ref([{}]);

        const getFooterInfo = () => {
            var DataInfo = {
                comp_id: compId.value || "",
                USR_ID: usrId.value || ""
            };
            window.AjaxPostLite("GetFooterForB2E", DataInfo, (res) => {
                if (res.MSG == null) {
                    compInfo.value = res.DATA.enties.CompanyInfo;
                } else {
                    //window.ShowDialog("error", "", res.MSG);
                }

            });
        }

        onMounted(() => {
            getFooterInfo();
        });
        return { compInfo };
    },
    template: html`
        <div class="enterprise">
            <figure v-if="webSite === 'b2c'">
                <a href="/">
                    <img
                        src="/Content/Img/Public/bestway_travel.png"
                        alt="百威旅遊"
                    />
                </a>
            </figure>
            <figure v-if="webSite === 'b2b'">
                <a href="/">
                    <img
                        src="/Content/Img/Public/bestway_travel.png"
                        alt="百威旅遊同業網"
                    />
                </a>
            </figure>
            <figure v-if="webSite === 'b2e'">
                <a href="/">
                    <img src="/Content/Img/bestway_travel.png" alt="百威旅遊" />
                </a>
            </figure>
            <div class="ent_text" v-if="webSite === 'b2c'">
                <div>百威旅行社股份有限公司</div>
                <div>交觀綜2132號．品保北1174號</div>
                <a href="mailto:service@bwt.com.tw" class="enterprise_mail">
                    客服信箱：service@bwt.com.tw
                </a>
                <br />
                <a href="/Company/About" class="enterprise_a">公司簡介</a>
                <a href="/contact/" class="enterprise_a">聯絡百威</a>
                <div class="order_edm" style="display: none">
                    <input type="text" placeholder="輸入EMAIL信箱" />
                    <button type="submit">訂閱電子報</button>
                </div>
            </div>
            <div class="ent_text" v-if="webSite === 'b2b'">
                <div>百威旅行社股份有限公司</div>
                <div>交觀綜2132號．品保北1174號</div>
                <a href="mailto:service@bwt.com.tw" class="enterprise_mail">
                    客服信箱：service@bwt.com.tw
                </a>
                <br />
                <a href="/Company/About" class="enterprise_a">公司簡介</a>
            </div>
            <div class="ent_text" v-if="webSite === 'b2e'">
                <div>{{compInfo[0].COMP_ANM}}</div>
                <div>{{compInfo[0].CITY_CNM}}{{compInfo[0].CNTA_DR}}<br>交觀綜2132號．品保北1174號</div>
                <a href="mailto:service@bwt.com.tw" class="enterprise_mail">客服信箱：service@bwt.com.tw</a>
                <div v-if="compInfo[0].lineat" style="font-size:13px;">LINE @@ 服務群組ID  :  {{compInfo[0].lineat}}</div>
                <a href="/Company/About" class="enterprise_a">公司簡介</a>
            </div>
            <div class="follow-us" v-if="webSite === 'b2c'">
                關注我們
                <ul class="follow-us-list">
                    <li class="follow-us-item fb">
                        <a
                            target="_blank"
                            href="https://www.facebook.com/BWT.voyage/"
                            rel="noreferrer noopener"
                        >
                            <svg class="icon_36_36 follow-us-icon">
                                <use
                                    xlink:href="#icon-fb"
                                    alt="Follow Us On Facebook"
                                ></use>
                            </svg>
                            Follow Us On Facebook
                        </a>
                    </li>
                    <li class="follow-us-item line">
                        <a
                            target="_blank"
                            href="https://line.me/R/ti/p/%40bestwaytravel"
                            rel="noreferrer noopener"
                        >
                            <svg class="icon_36_36 follow-us-icon">
                                <use
                                    xlink:href="#icon-line"
                                    alt="Follow Us On LINE"
                                ></use>
                            </svg>
                            Follow Us On Line
                        </a>
                    </li>
                    <li class="follow-us-item youtube">
                        <a
                            target="_blank"
                            href="https://www.youtube.com/channel/UCkHcVi2X8e_8vuQVyXSNaQA"
                            rel="noreferrer noopener"
                        >
                            <svg class="icon_36_36 follow-us-icon">
                                <use
                                    xlink:href="#icon-youtube"
                                    alt="Follow Us On youtube"
                                ></use>
                            </svg>
                            Follow Us On Youtube
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    `,
});
